export enum Ruta {
  TENANT = 'tenant',
  ID_PAGO = 'idPago',
  VALIDACION = 'validacion',
  PAGINA_NO_ENCONTRADA = 'pagina-no-encontrada',
  TRANSACCION = 'transaccion',
  PRODUCTO = 'producto',
}
